export const getYearRange = (currentYear: number, yearsBack: number, yearsAhead: number): Array<string> => {
  const lastYear = currentYear + yearsAhead;
  const range = yearsBack + yearsAhead + 1;
  return Array.from({ length: range }, (_, i) => (lastYear - i).toString());
};

const currentFullYear = new Date().getFullYear();

export const startRange = getYearRange(currentFullYear, 50, 0);
export const endRange = getYearRange(currentFullYear, 50, 1);
